<template>
    <div class="container">
        <div class="innerContain">
            <p>“搭把手”回收是宁波供销再生资源科技有限公司主营的关于垃圾前端分类减量、再生资源回收利用的大型社会服务项目。公司以现代智慧物流技术、车联网技术、智能物联网技术以及互联网信息化大数据技术为支撑，在政府指导和各参与方的共同努力下，全面建立一个“绿色智慧型”的再生资源回收体系，打通线上线下回收行业生态圈，将广大群众、企事业单位、商业综合、废品回收商、再生资源自用产业、垃圾处理单位等有机整合，打造一套完整的再生资源回收利用生态链，极大地减少填埋焚烧垃圾量，解决垃圾回收最后一公里的难题。</p>
            <p>
                ＂搭把手＂智能回收系统主要是通过先进的智能物联网回收终端并辅以必要的人工服务配套、智慧车联网物流清运体系，专业的分拣中心以及互联网信息化大数据管理平台，深入社区基层，从垃圾产生源头进行回收服务站点的全面布局，对生活垃圾中的可利用物建立＂人工+智能＂、＂固定+流动＂、＂线上大件预约+线下上门服务＂的＂全方位、全品类、全区域、一体化+公共服务＂型的回收服务体系，从根本上解决垃圾源头分类的减量化、资源化、无害化问题。
            </p>
            <p>搭把手垃圾分类智能回收站是为居民生活垃圾前端分类，可利用物回收研发的一款集成化智能设备，结合AI传感识别技术和物联网远程信息互动，通过公平诚信交易、高低价值资源有偿回收对前端垃圾分类进行有效引导，结合回收大数据分析，从而实现生活垃圾中可利用物的回收清运等全流程信息化管理。智能回收站可对居民端产生的各类再生资源进行回收，例如：饮料瓶（易拉罐）、废纸、塑料、玻璃、织物、金属、危险废弃物（定制）等，并可根据前端回收需要进行“1+N”的任意组合，以及承担社区分类垃圾袋的智能分发等。</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>
    .container{
        background-color: #F8F8F8;
        min-height: 100vh;
    }
    .nav_title{
        position: fixed;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background-color: white;
        text-align: center;
        color: #030303;
        font-size: 16px;
        font-weight: 600;
    }
    .nav_title .imgBox{
        position: absolute;
        left: 15px;
        top: -2px;
    }
    .innerContain{
        padding: 10px 20px;
    }
    .innerContain p{
        margin-top: 15px;
        font-size: 13px;
        text-indent: 2em;
        line-height: 20px;
    }


</style>
